import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const LeadsFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M14.2 10.74c2.4.46 4.47-1.61 4.01-4.01a3.397 3.397 0 0 0-2.68-2.67 3.409 3.409 0 0 0-4.01 4.01 3.398 3.398 0 0 0 2.67 2.67h.01ZM16.22 11.2h-2.45c-3.2 0-5.79 2.59-5.79 5.79v1.5c0 .84.68 1.52 1.52 1.52h10.99c.84 0 1.52-.68 1.52-1.52v-1.5c0-3.2-2.59-5.79-5.79-5.79Z"
      fill={color}
    />
    <Path
      d="M8.43 5.26a3.036 3.036 0 0 0-3.57 3.57c.23 1.19 1.2 2.16 2.38 2.38 2.14.41 3.98-1.44 3.57-3.57-.23-1.19-1.2-2.16-2.38-2.38Z"
      fill={color}
    />
    <Path
      d="M9.14 11.85H7.59c-3.19 0-5.81 2.61-5.81 5.81v.94c0 .78.63 1.41 1.41 1.41h3.53v-3.2c0-2.04.95-3.83 2.42-4.95v-.01Z"
      fill={color}
    />
  </Svg>
)

export default LeadsFilled
